import { Box, Link } from '@hover/blueprint';
import React from 'react';
import { useHistory, useLocation } from 'react-router';

import { TranslationNamespace, useTranslate } from 'src/shared/hooks';
import { Route as Routes } from 'src/shared/route';
import { buttonPressed } from 'src/shared/telemetry';

export const LoginAnotherWay = ({
  pageOrScreenName,
}: {
  pageOrScreenName: string;
}) => {
  const t = useTranslate(TranslationNamespace.SHARED);
  const { search } = useLocation();
  const history = useHistory();

  const handleNavigate = () => {
    buttonPressed({
      button_text: 'Log in another way',
      page_or_screen_name: pageOrScreenName,
      feature: 'onboarding',
    });
    history.push({
      pathname: `${Routes.SIGN_UP_ONBOARDING.path}/welcome`,
      search,
    });
  };

  return (
    <Link
      alignSelf="center"
      as={Box}
      color="neutral.500"
      mt={600}
      onClick={handleNavigate}
      sx={{
        cursor: 'pointer',
      }}
      textDecoration="underline"
    >
      {t('onboarding.loginAnotherWay')}
    </Link>
  );
};
